import { Box } from '@mui/material';

import { useChainPageWidgetStyles } from './useChainPageWidgetStyles';

interface ChainPageWidgetProps {
  children: React.ReactNode;
  className?: string;
}

export const ChainPageWidget = ({
  children,
  className,
}: ChainPageWidgetProps) => {
  const { classes, cx } = useChainPageWidgetStyles();

  return <Box className={cx(classes.root, className)}>{children}</Box>;
};
